import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { JssModule, TextField } from '@sitecore-jss/sitecore-jss-angular';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { TrackErrorDirective } from '@analytics/events';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';

@Component({
  selector: 'wl-server-error[rendering][message]',
  templateUrl: './server-error.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    NgbAlert,
    TrackErrorDirective,
    FaIconComponent,
    AutomationIdDirective,
    JssModule,
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    ExperienceEditorPreviewDirective,
  ],
})
export class ServerErrorComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() message?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() messageDescription?: TextField;
}
